import { Box } from '@mui/material';

import AccountBlack from '~/assets/img/icons/black/MyDianomi_AccountBlack.svg';
import AdManagerBlack from '~/assets/img/icons/black/MyDianomi_AdManagerBlack.svg';
import AnalyticsBlack from '~/assets/img/icons/black/MyDianomi_AnalyticsBlack.svg';
import BillingBlack from '~/assets/img/icons/black/MyDianomi_BillingBlack.svg';
import HelpCenterBlack from '~/assets/img/icons/black/MyDianomi_HelpCenterBlack.svg';
import InsightsBlack from '~/assets/img/icons/black/MyDianomi_InsightsBlack.svg';
import InventoryBlack from '~/assets/img/icons/black/MyDianomi_InventoryBlack.svg';
import NewAdBlack from '~/assets/img/icons/black/MyDianomi_NewAdBlack.svg';
import OverviewBlack from '~/assets/img/icons/black/MyDianomi_OverviewBlack.svg';
import SupplyManagerBlack from '~/assets/img/icons/black/MyDianomi_SupplyManagerBlack.svg';
import AccountGreen from '~/assets/img/icons/green/MyDianomi_AccountGreen.svg';
import AdManagerGreen from '~/assets/img/icons/green/MyDianomi_AdManagerGreen.svg';
import AnalyticsGreen from '~/assets/img/icons/green/MyDianomi_AnalyticsGreen.svg';
import BillingGreen from '~/assets/img/icons/green/MyDianomi_BillingGreen.svg';
import HelpCenterGreen from '~/assets/img/icons/green/MyDianomi_HelpCenterGreen.svg';
import InsightsGreen from '~/assets/img/icons/green/MyDianomi_InsightsGreen.svg';
import InventoryGreen from '~/assets/img/icons/green/MyDianomi_InventoryGreen.svg';
import NewAdGreen from '~/assets/img/icons/green/MyDianomi_NewAdGreen.svg';
import OverviewGreen from '~/assets/img/icons/green/MyDianomi_OverviewGreen.svg';
import SupplyManagerGreen from '~/assets/img/icons/green/MyDianomi_SupplyManagerGreen.svg';

import styles from './styles';

/** Black icons (default state) */
const blackIconMap: Record<string, string> = {
  Account: AccountBlack,
  AdManager: AdManagerBlack,
  Analytics: AnalyticsBlack,
  Insights: InsightsBlack,
  Billing: BillingBlack,
  NewAd: NewAdBlack,
  CaseStudy: HelpCenterBlack,
  Overview: OverviewBlack,
  SupplyManager: SupplyManagerBlack,
  Inventory: InventoryBlack,
};

/** Green icons (active/hover state) */
const greenIconMap: Record<string, string> = {
  Account: AccountGreen,
  AdManager: AdManagerGreen,
  Analytics: AnalyticsGreen,
  Insights: InsightsGreen,
  Billing: BillingGreen,
  NewAd: NewAdGreen,
  CaseStudy: HelpCenterGreen,
  Overview: OverviewGreen,
  SupplyManager: SupplyManagerGreen,
  Inventory: InventoryGreen,
};

type SidebarItemIconProps = {
  icon?: string;
  sidebarOpen?: boolean;
  active?: boolean;
  hover?: boolean;
};

function SidebarItemIcon({ icon, active, hover, sidebarOpen }: SidebarItemIconProps) {
  if (!icon) {
    return null;
  }

  const iconStyles = styles.itemIcon({ sidebarOpen, active, hover });
  const useGreen = active || hover;
  const iconMap = useGreen ? greenIconMap : blackIconMap;

  const itemImgSrc = iconMap[icon];
  if (!itemImgSrc) {
    return (
      <Box sx={iconStyles}>
        <img src={useGreen ? OverviewGreen : OverviewBlack} alt="Overview" />
      </Box>
    );
  }

  return <Box component="img" sx={iconStyles} src={itemImgSrc} alt="Entry menu icon" />;
}

export default SidebarItemIcon;
